import { createSelector } from "reselect";

import { createGetBetsByParams, getErrorType, getLoading } from "src/selectors";
import { Status } from "./types";

export const createGetCount = (gameId: number) =>
  createSelector(
    [
      getLoading,
      createGetBetsByParams([gameId], [], ["pending"]),
      createGetBetsByParams([gameId], [], ["selected"]),
    ],
    (loading, pending, selected) => (loading ? pending.length : selected.length)
  );

export const createGetStatus = (gameId: number) =>
  createSelector(
    [createGetCount(gameId), getErrorType, getLoading],
    (count, errorType, loading): Status => {
      const isError = errorType !== null;
      const isActive = count > 0;
      const isDisabled = isError || !isActive;
      const isLoading = loading;
      if (isError) {
        return "error";
      } else if (isLoading) {
        return "loading";
      } else if (isDisabled) {
        return "disabled";
      } else {
        return "basic";
      }
    }
  );
